import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stores: [],
};

const storeSlice = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    setStores: (state, action) => {
      state.stores = action.payload
        // createdAt:action.payload.createdAt.toDate()
    },
    
  },
});

export const {
 setStores
} = storeSlice.actions;
export const storeReducer = storeSlice.reducer;